import { useQuery } from '@tanstack/react-query';
import { ResourceType } from 'libs.library_manager';
import { ApiClientService, useApiClient } from 'libs.react_internal';
// This is a library API hook. Why it's in translation_workbench?
// TODO: Move this to libs.library_manager or appropriate package.
export function useLibraryDetails(id, type = ResourceType.ACTIVITY, withUrl = false) {
    const { get } = useApiClient(ApiClientService.LIBRARY);
    return useQuery({
        queryKey: ['library', 'details', id],
        queryFn: () => {
            const params = withUrl ? { withUrl: true } : {};
            return get(`v1/${type}/${id}`, { params });
        },
        enabled: !!id,
        retry: false,
    });
}
